module.exports = __webpack_public_path__ + "img/caja_pizza.1b6c1ce3.png";